import { userService } from "../services/user.services"
import GlobalContext from "../components/Context/GloablContext"
import { useContext } from "react"

/* eslint-disable max-len */
export const handleSessionError = (error, key) => {
    // const { setToastmessage,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    

    const handleRefreshToken = async () => {
        const response = await userService.RefreshToken()
        if(response.error === false && response.data.success_status === true) {
            sessionStorage.setItem('IdToken', response.data.data)
        } else{
            // if(response?.message?.response?.status===400){
            //     const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
            //     sessionStorage.setItem('custom-status', 'inactive');
            //     sessionStorage.clear();
            //     localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            //     window.location.href = '/';
            // }
        }
    }
    
    if(key === 'rtkquery') {
        //handleRefreshToken();
    }


    let errorMessage = '';
    if(error.response) {
        switch(error.response.status) {
        case 401: 
            //handleRefreshToken();
            // errorMessage = 'Your session has timed out. Redirecting to Login Screen.';
            // setTimeout(() => {
                
            //     sessionStorage.clear();
            //     window.location.href = '/';
            // }, [3000])
            break;
        // case 400:
        //     errorMessage = error.response.data.message || 'There was an error while performing this action.';
        //     break;
        // case 403:
        //     errorMessage = error.response.data.message || 'There was an error while performing this action.';
        //     break;
        // case 404:
        //     errorMessage = error.response.data.message || "You are not authorized to access this resource."
        //     break;
        case 500:
            errorMessage = "There was an internal server error. Please try again after some time."
            break;
        // case 409:
        //     errorMessage = error.response.data.message || "There was an internal server error. Please try again after some time."
        //     break;
        }
    } else {
        errorMessage = "Network error. Please try again after some time."
    }
    return { error: true, message: error }
}